import "./App.css";
import React, { useState, useEffect } from "react";
import moment from "moment-timezone";
import routes from "./config/routes.json";
import { HashRouter as Router, Switch, Route, Link } from "react-router-dom";
import MtvContainer from "./components/MtvContainer/MtvContainer";
import { appConfig } from "./config/appConfig";
import RoomContainer from "./components/RoomContainer";
import SessionContainer from "./components/SessionContainer";
import { Spinner, Alert } from "react-vm-component-library";
import { makeHttpCall } from "./utils/HttpHelpers";
import { getBaseUrl, getEventId, getName, getSurname, getUserId, getAccessToken } from "./utils/QueryString";
import AppContainer from "./components/PageContainer";
import { getHashCode, toApiParams } from "./utils/Tools";
import * as Storage from "./utils/SetLocalstorage";
import {setMtvCookies, removeMtvCookies } from "./utils/Cookies";
import { tryGetEmail } from "./utils/AppHelpers";
// uuidv4(); // ⇨ '9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d'

//<Link to="/about">About</Link>
const App = () => {
  const [userLogin, setUserLogin] = useState(null);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    (async () => {
      const qsEmail = tryGetEmail(appConfig);
      
      const apiCallParams = {
        event_id: getEventId() || 460,
        email:qsEmail,
        //partner_user_id:213
      };

      const name = getName();
      const surname = getSurname();
      const userId = getUserId();
      const acessToken = getAccessToken();

      if(name) apiCallParams.firstname = name;
      if(surname) apiCallParams.surname = surname;

      
      //`https://api-lb.virtual-meeting.net/v1/logins/user_logins.json?partner_user_id=${partner_user_id}`
      let url = `https://${getBaseUrl()}/v1/logins/user_logins.json?${Object.keys(
      apiCallParams
      ).map((key) => `${key}=${apiCallParams[key]}`).join("&")}`;
      let isGetMethod = false;
      if(userId && acessToken){//Tech.App
        isGetMethod = true;
        delete apiCallParams.firstname;
        delete apiCallParams.surname;
        delete apiCallParams.email;

        apiCallParams.user_id = userId;
        apiCallParams.access_token = acessToken;
        apiCallParams.include_user = 1;
        url = `https://${getBaseUrl()}/v1/logins.json?${toApiParams(apiCallParams)}`
      }
  
      const hash = `random_user_${getHashCode(url)}`;
      console.log(getHashCode(url))
      const cachedData = Storage.get(hash);
      if(cachedData && cachedData?.date === moment().format("YYYY-MM-DD HH")){
        setUserLogin(cachedData?.user);
        removeMtvCookies()
        setMtvCookies(cachedData?.user);
        return;
        
      }

   
      const requestCall = await makeHttpCall({
        url,
        method: isGetMethod ? "GET":"POST",
        isVm: true,
      });
      if (!requestCall?.ok) {
        setError({ text: "Something went wrong!" });
        removeMtvCookies()
        return;
      }
      console.log(requestCall?.data);
      const lUserData = requestCall?.data?.length > 0 ? requestCall?.data[0]: requestCall?.data;
      setUserLogin(lUserData);
      const vmUser = lUserData;
      if(name) vmUser.firstname = name;
      if(surname) vmUser.surname = surname;

      if(lUserData?.user?.firstname) vmUser.firstname = lUserData.user.firstname;
      if(lUserData?.user?.surname) vmUser.surname = lUserData.user.surname;
      
      Storage.store(hash, {
        user: vmUser,
        date: moment().format("YYYY-MM-DD HH"),
      });
      removeMtvCookies()
      setMtvCookies(vmUser);
      
    })();
  }, []);

  if (error)
    return (
      <AppContainer>
        <Alert colorType="danger">
          <i className="fas fa-exclamation-triangle mr-3"></i>
          <span>{error?.text}</span>
        </Alert>
      </AppContainer>
    );

  if (!userLogin) return <Spinner />;
  const eventId = getEventId() || 460
  const mtvSetup = {...appConfig?.mtvSetup,  event_id: eventId, base_api:getBaseUrl()};
  return (
    <AppContainer>
      <Router>
        <div>
          <Switch>
            <Route path={routes.SESSIONS}>
              <SessionContainer mtvSetup={mtvSetup} />
            </Route>
            <Route path={routes.ROOMS}>
              <RoomContainer mtvSetup={mtvSetup} />
            </Route>
            <Route path={routes.Home}>
              {/* <Link to={`/rooms/2721`}>Room id =</Link> */}
              <MtvContainer mtvSetup={mtvSetup} />
            </Route>
          </Switch>
        </div>
      </Router>
    </AppContainer>
  );
};

export default App;
